
import React from "react";

export {AppLevelNoRoute404};

const AppLevelNoRoute404 = (props: any) => {
  return(<>404 Not found</>)
}
